import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ErpAuthProvider, useErpAuth } from "@/context/ErpAuthContext";
import { Toaster } from "@/components/ui/sonner";
import CookieConsent from "@/components/CookieConsent";
import PublicSite from "@/pages/PublicSite";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ErpLogin from "@/pages/erp/ErpLogin";
import ErpDashboard from "@/pages/erp/ErpDashboard";
import ArticlesList from "@/pages/ArticlesList";
import ArticleDetail from "@/pages/ArticleDetail";
import TermsPage from "@/pages/TermsPage";
import ServicesHub from "@/pages/ServicesHub";
import ServiceDetail from "@/pages/ServiceDetail";
import AboutPage from "@/pages/AboutPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-[#0F1E36]">
        Se încarcă...
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function ErpProtected({ children }) {
  const { user } = useErpAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-[#0B1424]">
        Se încarcă...
      </div>
    );
  if (!user) return <Navigate to="/angajati/login" replace />;
  return children;
}

function ErpArea() {
  return (
    <ErpAuthProvider>
      <Routes>
        <Route path="login" element={<ErpLogin />} />
        <Route
          index
          element={
            <ErpProtected>
              <ErpDashboard />
            </ErpProtected>
          }
        />
        <Route path="*" element={<Navigate to="/angajati" replace />} />
      </Routes>
    </ErpAuthProvider>
  );
}

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <AuthProvider>
              <PublicSite />
            </AuthProvider>
          }
        />
        <Route
          path="/admin/login"
          element={
            <AuthProvider>
              <AdminLogin />
            </AuthProvider>
          }
        />
        <Route
          path="/admin"
          element={
            <AuthProvider>
              <Protected>
                <AdminDashboard />
              </Protected>
            </AuthProvider>
          }
        />
        <Route path="/articole" element={<ArticlesList />} />
        <Route path="/articole/:slug" element={<ArticleDetail />} />
        <Route path="/servicii" element={<ServicesHub />} />
        <Route path="/servicii/:slug" element={<ServiceDetail />} />
        <Route path="/despre" element={<AboutPage />} />
        <Route path="/termeni" element={<TermsPage />} />
        <Route path="/angajati/*" element={<ErpArea />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-right" richColors />
      <CookieConsent />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
